var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHero3 = function SvgHero3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffb300",
    d: "M80 40A40 40 0 1 1 40 0a40 40 0 0 1 40 40"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M32.807 50.802a3.6 3.6 0 1 0 3.593 3.593 3.613 3.613 0 0 0-3.593-3.593m23.434-25.2H29.558l-1.615-3.6h-5.942v3.6h3.6l6.475 13.676-2.522 4.324a6.5 6.5 0 0 0-.36 1.791 3.615 3.615 0 0 0 3.6 3.6h21.593v-3.6L34.771 41.8h13.336a3.3 3.3 0 0 0 3.058-1.8l6.455-12.091a1.568 1.568 0 0 0-1.384-2.304Zm-5.434 25.2a3.6 3.6 0 1 0 3.593 3.593 3.613 3.613 0 0 0-3.593-3.593"
  })));
};
export default SvgHero3;